import axiosClient from "../../../../system/helpers/axiosConfig";
import { postNewChatParams } from "../helpers";

export const postNewChat = (params: postNewChatParams) => {
  return axiosClient.post("/api/im", params).then((r) => r.data);
};
